import {
  CheckCircleFilled,
  FilterOutlined,
  PlusOutlined,
  UndoOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Badge, Button, Tooltip } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetFilteredPlanGroupsApi from "../../api/GetFilteredPlanGroupsApi";
import { GetPlanGroupsApi } from "../../api/GetPlanGroupsApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddPlanGroupModal from "../../components/modal/add/AddPlanGroupModal";
import PlanGroupFilterModel from "../../components/modal/filters/PlanGroupFilterModel";
import PageLoader from "../../components/sub/PageLoader";
import PlanGroupsTable from "../../components/tables/PlanGroupsTable";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function PlanGroups() {
  const [addModal, setAddModal] = useState(false);
  const [canStart, setCanStart] = useState(false);
  const [canShowTable, setCanShowTable] = useState(false);
  const [data, setData] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const [page, setPage] = useState(1);
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    getPlanGroups(1);
    setFilterBy({ name: "", scale: "" });
  }, []);

  async function getPlanGroups(num) {
    setTableLoading(true);
    const apiResponse = await GetPlanGroupsApi(num, LIMIT_PER_PAGE );
    if (apiResponse.message === "success") {
      if (apiResponse.groups?.length) {
        /*To show add component */
        !canShowTable && setCanShowTable(true);
      }
      setData(apiResponse);
      setCanStart(true);
      setTableLoading(false);
      setPage(num);
    }
  }

  async function getFilterPlanGroups(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredPlanGroupsApi(
      values.name,
      values.scale,
      num, 
      LIMIT_PER_PAGE
    );
    if (apiResponse.message === "success") {
      setData(apiResponse);
      setTableLoading(false);
      setFilterStatus(true);
      setFilterBy({ name: values.name, scale: values.scale });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilterPlanGroups(filterBy, num);
    } else {
      getPlanGroups(num);
    }
  }

  function resetFilter() {
    getPlanGroups(1);
    setFilterStatus(false);
    setFilterBy();
  }

  const right = (
    <>
      {canShowTable && (
        <>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => resetFilter()}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
      {permissionAbility(userLevel, "plan-groups", "add") && (
        <Tooltip placement="left" title={"Add Group"}>
          <Button
            onClick={() => setAddModal(true)}
            shape="circle"
            className="ml-3"
            type="primary"
            icon={<PlusOutlined />}
          ></Button>
        </Tooltip>
      )}
    </>
  );

  const left = (
    <div className="text-lg pri-font">
      {"Plan Groups (" + (data?.totalCount || 0) + ")"}
    </div>
  );

  function showEmptyPlanGroups() {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No groups available
          </div>
          {permissionAbility(userLevel, "plan-groups", "add") && (
            <>
              <div className="mb-3 text-gray-400">
                Add different groups of your plans
              </div>
              <Button onClick={() => setAddModal(true)} type="primary">
                Add a group
              </Button>
            </>
          )}
        </div>
      </div>
    );
  }
  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            canShowTable ? (
              <PlanGroupsTable
                changePage={(num) => changeTablePage(num)}
                data={data}
                loading={tableLoading}
                page={page}
              />
            ) : (
              showEmptyPlanGroups()
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddPlanGroupModal
        visible={addModal}
        handleCancel={() => setAddModal(false)}
        handleOk={() => getPlanGroups(1)}
      />
      <PlanGroupFilterModel
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => getFilterPlanGroups(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default PlanGroups;
